<template>
  <div>
    <validated-multiselect id="noteStatus" label="Change Status" v-model="form.status" :options="statusOptions" />
    <validated-input v-if="form.status === 'escalated'" id="escalationReason" label="Escalation Reason *" type="textarea" v-model="form.escalationReason" />
    <validated-input id="noteText" label="Note" type="textarea" v-model="form.note" />
    <div class="d-flex justify-content-end mt-2" style="gap: 6px;">
      <b-button size="sm" variant="outline-secondary" @click="$emit('cancel')">Cancel</b-button>
      <b-button size="sm" variant="primary" :disabled="isDisabled || saving" @click="handleSubmit">
        {{ saving ? 'Saving...' : 'Save Note' }}
      </b-button>
    </div>
  </div>
</template> 
  
<script>
import ValidatedMultiselect from '@/components/shared/ValidatedMultiselect.vue';
import ValidatedInput from '@/components/shared/ValidatedInput.vue';
   
export default {     
  name: 'ClaimNoteForm', 
  components: { ValidatedMultiselect, ValidatedInput },
  props: {
    saving: { type: Boolean, default: false },
    initialStatus: { type: String, default: null },
  },
  data() {
    return {
      form: { status: this.initialStatus, escalationReason: '', note: '' },
    };
  },

  computed: {
    statusOptions() {
    return [
        { value: null,              label: '— No status change —' },
        { value: 'open',            label: 'Open' },
        { value: 'in_progress',     label: 'In Progress' },
        { value: 'pending_carrier', label: 'Pending Carrier' },
        { value: 'escalated',       label: 'Escalated' },
      ];
    },
    isDisabled() {
      if (this.form.status === 'escalated') return !this.form.escalationReason.trim();
      return !this.form.note.trim();
    },
  },
  methods: {
    handleSubmit() {
      if (this.isDisabled) return;
      this.$emit('submit', { ...this.form });
      this.form = { status: null, escalationReason: '', note: '' };
    },
  },
};
</script>
